import { render, staticRenderFns } from "./input-radio-cmp-extended.vue?vue&type=template&id=2c8d9d1e&scoped=true"
import script from "./input-radio-cmp-extended.vue?vue&type=script&lang=js"
export * from "./input-radio-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./input-radio-cmp-extended.vue?vue&type=style&index=0&id=2c8d9d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d9d1e",
  null
  
)

export default component.exports